interface CacheIndicatorProps {
	cached?: boolean
	className?: string
}

/**
 * Indicator to show when a response came from cache (faster)
 * Optional visual indicator for users to understand performance
 */
export const CacheIndicator = ({ cached, className = '' }: CacheIndicatorProps) => {
	if (!cached) {
		return null
	}

	return (
		<span
			className={`inline-flex items-center gap-1 text-xs text-gray-400 ${className}`}
			title="Respuesta servida desde caché - más rápida"
		>
			<svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={2}
					d="M13 10V3L4 14h7v7l9-11h-7z"
				/>
			</svg>
			<span className="hidden sm:inline">Respuesta instantánea</span>
		</span>
	)
}
